import {Input, Spin } from 'antd';
import { BOXES } from 'api';
import get from 'lodash/get';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import useFetch from 'utils/fetch/useFetch';
import { LAGERBOX, TENANTS } from '../../api';
import List from './components/List';

function UserPairing() {
  const [users, setUsers] = useState([]);
  const [pairList, setPairList] = useState([]);
  const [limit, setLimit] = useState(10);
  const options = useSelector((state) =>
    get(state, `fetch.users.filter`, null),
  );
  const { t } = useTranslation();
  const { data, getData, loading, updateData, total, loadMore } = useFetch(
    LAGERBOX+TENANTS
  );

  useEffect(() => {
    getData({
    });
  }, []);
  
 const {
    data: list,
    getData: getList,
    postData: postList,
    loading: loadingList,
    updateData: updateList,
  } = useFetch(BOXES, {
    uniqId: 'boxes',
    autoFetch: false,
  });

  useEffect(() => {
    if (limit > 10) {
      let data= getData({
        role: 'client',
        limit,
      });
    }
  }, [limit]);

  useEffect(() => {
    if (list && !setPairList) setPairList(list.length + 10);
  }, [list]);

  return (
    <Spin spinning={loading}>
      {users && (
        <>
          <List
            getList={getData}
            list={data}
            
          />
        </>
      )}
    
    </Spin>
  );
}

UserPairing.propTypes = {};

export default UserPairing;
